const o = "Fast-forms: ", s = "_";

export { s as COMPOUND_KEY_JOIN_SYMBOL, o as ERROR_PREFIX };
//# sourceMappingURL=index.js.map
